import { render } from "./modal-image-preview.vue?vue&type=template&id=cfd08fd2&scoped=true"
import script from "./modal-image-preview.vue?vue&type=script&lang=js"
export * from "./modal-image-preview.vue?vue&type=script&lang=js"

import "./modal-image-preview.vue?vue&type=style&index=0&id=cfd08fd2&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfd08fd2"]])

export default __exports__